import React, { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  icon?: ReactNode;
  actions?: ReactNode;
}

/**
 * Consistent page header component to be used across all pages
 * Includes support for optional icon and action buttons
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, icon, actions }) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        {icon && (
          <div className="text-primary mr-3 text-xl">
            {icon}
          </div>
        )}
        <h1 className="text-2xl font-bold text-stone-800">{title}</h1>
      </div>
      
      {actions && (
        <div className="flex items-center space-x-2">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader; 